import { useEffect } from 'react';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { getMarketingDataFromUrl } from '../../lib/side-effects';
import { setActiveFlow } from '../../store/system';
import ContactSales from './contact-sales';
import SubscriptionDetails from './subscription-details';
import TrialBanner from './trial-banner';

const FreeTrial = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setActiveFlow('trial-extension'));
    dispatch(getMarketingDataFromUrl());
  }, []);

  return (
    <div>
      <TrialBanner secondLineText='Avalara AvaTax API trial' />
      <SubscriptionDetails />
      <ContactSales />
    </div>
  );
};

export default FreeTrial;
